import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { globalErrorLostConnectionToastKey, globalToastKey } from '@cpak/consts';

@Injectable({
  providedIn: 'root',
})
export class CustomMessageService {
  private readonly severity = 'custom-success';
  constructor(private messageService: MessageService) {}

  public showCopyMessage(data: string): void {
    this.messageService.add({ severity: this.severity, summary: data, key: globalToastKey });
  }

  public showErrorMessage(message: string, sticky?: boolean): void {
    this.messageService.add({
      severity: 'custom-error',
      summary: message,
      key: globalToastKey,
      sticky: sticky || false,
    });
  }

  public showSuccessMessage(message: string): void {
    this.messageService.add({ severity: this.severity, summary: message, key: globalToastKey });
  }

  public showMessage(text: string, severity?: string, key?: string, style?: string, sticky: boolean = false): void {
    this.messageService.add({
      severity: severity || this.severity,
      summary: text,
      key: key,
      styleClass: style,
      sticky,
    });
  }

  public showInfoMessage(text: string, key?: string, style?: string): void {
    this.messageService.add({
      severity: 'custom-info',
      summary: text,
      key: key || globalToastKey,
      styleClass: style,
    });
  }

  public showErrorMessageLostConnection(text: string, style?: string): void {
    this.messageService.add({
      severity: 'custom-error',
      summary: text,
      key: globalErrorLostConnectionToastKey,
      sticky: true,
      styleClass: style,
    });
  }
}
